import React from "react";
import FAQSection from "./faqs";
import ConnectToOurUniverse from "../contact";

const FaqsMain = () => {
  return (
    <>
      <FAQSection />

      <ConnectToOurUniverse />
    </>
  );
};

export default FaqsMain;
